var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.00014,
    cy: 2.57143,
    r: 2.12143,
    stroke: "#5D6F88",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 7.25693H6.85714C9.34183 7.25693 11.3803 9.16758 11.5834 11.5998H0.416629C0.619735 9.16758 2.65817 7.25693 5.14286 7.25693Z",
    stroke: "#5D6F88",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.9785749dfd186afdd6b2afd1f76aea7f.svg";
export { ForwardRef as ReactComponent };